export interface IForgotPassword{
    Email:string,
    Link:string,
}
export class ForgotPassword implements IForgotPassword{
    Email:string = '';
    Link:string = '';
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/forgot-password/forgot-password.ts